export default "__VITE_ASSET__DjvKwf2j__"